import React, { useState } from "react";
import { UserStoryDto } from "../../dto/UserStoryDto";
import "./styles/CassetteTapeStack.css";

export interface CassetteTapeStackProps {
  stories: UserStoryDto[];
  lang: string;
  selectedId: number;
  onSelect: (id: number) => void;
  /** how many tapes per row before wrapping up */
  perColumn?: number;
}

const HANDWRITING_FONTS = [
  `"itc-bradley-hand-std", sans-serif`,
  `"pf-reminder", sans-serif`,
  `"shantell-sans-bouncy", sans-serif`,
];

const CassetteTapeStack = ({
  stories,
  lang,
  selectedId,
  onSelect,
  perColumn = 5,
}: CassetteTapeStackProps) => {
  const [shifts] = useState<number[]>(() =>
    stories.map(() => Math.floor(Math.random() * 18 - 9)),
  );

  const [fonts] = useState<string[]>(() =>
    stories.map(() => {
      const idx = Math.floor(Math.random() * HANDWRITING_FONTS.length);
      return HANDWRITING_FONTS[idx];
    }),
  );

  return (
    <div className="tape-stack">
      {stories.map((userStory, i) => {
        const row = i % perColumn;
        const column = Math.floor(i / perColumn);
        const isSelected = userStory.id === selectedId;
        const shiftPx = `${shifts[i]}px`;
        const chosenFont = fonts[i];

        return (
          <div
            key={userStory.id}
            className={`tape${isSelected ? " selected" : ""}`}
            style={
              {
                "--row": row,
                "--column": column,
                "--random": shiftPx,
              } as React.CSSProperties
            }
            onClick={() => onSelect(userStory.id)}
          >
            <div
              className="tape-label"
              style={{
                fontFamily: chosenFont,
                backgroundImage: `url("${userStory.visualUrl}")`,
                backgroundColor: "#6DB3F2",
                backgroundPosition: "center",
              }}
            >
              <span>
                {lang === "EN" ? userStory.titleEN : userStory.titleDE}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CassetteTapeStack;
